import { render } from "./uiSimpleDropdown.vue?vue&type=template&id=53c90738&scoped=true"
import script from "./uiSimpleDropdown.vue?vue&type=script&lang=js"
export * from "./uiSimpleDropdown.vue?vue&type=script&lang=js"

import "./uiSimpleDropdown.vue?vue&type=style&index=0&id=53c90738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c90738"]])

export default __exports__